var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "menu--section-valentines_day_drinks" }, [
    _vm.menu.menu_property === "wv"
      ? _c("div", [_vm._m(0), _vm._v(" "), _vm._m(1)])
      : _c("div", [_vm._m(2), _vm._v(" "), _vm._m(3)]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _c("img", {
        attrs: {
          alt: "Valentine's Day Chocolate Covered Strawberry Martini Drink",
          src: "/library/images/menu/valentines-day-drinks-chocolate-covered-strawberry-martini-wv.jpg",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _c("img", {
        attrs: {
          alt: "Valentine's Day Lover's Negroni Drink",
          src: "/library/images/menu/valentines-day-drinks-lovers-negroni-wv.jpg",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _c("img", {
        attrs: {
          alt: "Valentine's Day Chocolate Covered Strawberry Martini Drink",
          src: "/library/images/menu/valentines-day-drinks-chocolate-covered-strawberry-martini.jpg",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _c("img", {
        attrs: {
          alt: "Valentine's Day Lover's Negroni Drink",
          src: "/library/images/menu/valentines-day-drinks-lovers-negroni.jpg",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }